import { NgModule, Compiler, COMPILER_OPTIONS, CompilerFactory } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FarrisRenderEngineComponent } from './farris-render-engine.component';
import { RenderViewComponent } from './render-view/render-view.component';
import { DgWrapperComponent } from './components/dg-wrapper/dg-wrapper.component';
import { CacheService, HttpService, SessionService } from '@ecp-caf/caf-common';
import { JitCompilerFactory } from '@angular/platform-browser-dynamic';
import { CommandMetadataService } from './commands/command-metadata.service';
import { CommandControllerBuilder } from './commands/command-controller-builder';
import { EventBus } from '@farris/devkit';
import { KeybindingService } from './common/service/keybinding.service';

export function createCompiler(compilerFactory: CompilerFactory) {
  return compilerFactory.createCompiler();
}

@NgModule({
  declarations: [
    FarrisRenderEngineComponent, RenderViewComponent, DgWrapperComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  entryComponents: [
    FarrisRenderEngineComponent, RenderViewComponent, DgWrapperComponent
  ],
  exports: [
    FarrisRenderEngineComponent, RenderViewComponent, DgWrapperComponent
  ],
  providers: [
    { provide: COMPILER_OPTIONS, useValue: {}, multi: true },
    { provide: CompilerFactory, useClass: JitCompilerFactory, deps: [COMPILER_OPTIONS] },
    { provide: Compiler, useFactory: createCompiler, deps: [CompilerFactory] },
    CacheService, HttpService, SessionService,
    CommandControllerBuilder, CommandMetadataService, KeybindingService,
    EventBus
  ]
})
export class FarrisRenderEngineModule { }
